/* eslint-disable no-console */
import {Tabs as TabsAnt} from 'antd';
import {TabsType} from 'antd/es/tabs';
import React from 'react';

import {Itabs} from '../../interface/Tab';

const TabsESG: React.FC<{
  array: Itabs[];
  defaultKey?: string;
  type?: TabsType;
  noPadding?: boolean;
  hidden?: boolean;
  destroy?: boolean;
  activeKey?: string;
  setDefaultKey: React.Dispatch<React.SetStateAction<string>>;
}> = ({
  array,
  type,
  defaultKey,
  noPadding = false,
  hidden = false,
  destroy = true,
  setDefaultKey
}) => {
  // const [mainActive, setMainActive] = useState<undefined | string>(
  //   array?.[0]?.id
  // );

  // useEffect(() => {
  //   if (defaultKey) {
  //     setMainActive(defaultKey);
  //   }
  // }, [defaultKey]);

  // useEffect(() => {
  //   setMainActive(array?.[0]?.id);
  // }, [array]);

  // useEffect(() => {
  //   setDefaultKey('');
  // }, [mainActive]);

  return (
    <TabsAnt
      className={`tab ${noPadding ? 'noPadding' : ''}`}
      type={type ?? 'card'}
      items={array?.map((item) => {
        return {
          key: item.id,
          label: item.name,
          children: item.component,
          disabled: item?.disabled,
          forceRender: item?.forceRender ?? false
        };
      })}
      onChange={(value) => {
        setDefaultKey(value);
      }}
      // onTabClick={(value) => {
      //   setMainActive(value);
      // }}
      tabBarGutter={48}
      destroyInactiveTabPane={destroy}
      hidden={hidden}
      activeKey={defaultKey === '' ? array?.[0]?.id : defaultKey}
    />
  );
};

export default TabsESG;
